export default {
    isNavigatingBack(state) {
        return state.navigating_back
    },
    routes(state) {
        const findRoutes = (children) => {
            const result = []

            children.forEach((child) => {
                if (child.children && child.children.any()) {
                    result.push(...findRoutes(child.children))
                }
                result.push(child)
            })

            return result
        }

        return findRoutes(state.routes)
    },

    available_routes(state, getters, rootState, rootGetters) {
        return getters.routes.filter((route) => {
            if (route.meta) {
                // accomodate for blocked roles
                if (
                    route.meta.blocked_roles &&
                    rootGetters['auth/has_role'](route.meta.blocked_roles)
                ) {
                    return false
                }

                if (route.meta.require_auth == null) {
                    return true
                }
                if (route.meta.require_auth === rootGetters['auth/is_authenticated']) {
                    if (route.meta.require_auth) {
                        var hasRole = rootGetters['auth/has_role'](route.meta.require_role)
                        return hasRole
                    }
                    return true
                }
                return false
            }
            return true
        })
    },

    isLoading(state) {
        return state.loading
    },

    getByName(state, getters) {
        return (name) => getters.route_map[name]
    },

    route_map(state, getters) {
        return getters.available_routes.toObject((r) => r.name)
    },

    breadcrumb(state, getters) {
        const findCurrent = function (children, breadcrumb) {
            breadcrumb = breadcrumb || []

            for (var i = 0; i < children.length; i++) {
                var child = children[i]

                if (!child) {
                    throw "Can't find breadcrumb for null route. Please check your route tree."
                }

                if (child.name === state.currentRoute.name) {
                    breadcrumb.push(child)
                    break
                } else if (child.children && child.children.any()) {
                    breadcrumb = findCurrent(child.children, breadcrumb)
                    if (breadcrumb.any()) {
                        // named route is part of the breadcrumb.
                        // if there is no name, this is probably a nameless parent as router does not
                        // allow a named parent to have a default child route. Thus, we should place the
                        // default (named) child in the breadcrumb instead.
                        if (!child.name && child.children && child.children.any()) {
                            var defaultChild = child.children.find((c) => !c.path)
                            if (defaultChild) {
                                breadcrumb.unshift(defaultChild)
                            }
                        } else {
                            breadcrumb.unshift(child)
                        }
                        break
                    }
                }
            }
            return breadcrumb
        }

        var topLevelRoutes = state.menuItems
            .where((mi) => mi.route)
            .map((mi) => getters.getByName(mi.route)) // This returns undefined if the route is inaccessible (auth)
            .where((r) => !!r)

        return findCurrent(topLevelRoutes)
    },

    isInBreadcrumb(state, getters) {
        return (route) => {
            var name = route.name || route
            return getters.breadcrumb.any((breadcrumbRoute) => {
                return breadcrumbRoute.name === name
            })
        }
    },

    nav_menu_items(state, getters, rootState, rootGetters) {
        const findItems = (children) => {
            const result = []

            children.forEach((child) => {
                if (child.route) {
                    // Child is a page/route, replace with correct meta
                    var route = getters.route_map[child.route]
                    if (route) {
                        result.push({
                            url: { name: route.name },
                            name: child.title || route.meta.title,
                            icon: child.icon || route.meta.icon,
                            slug: child.slug || route.meta.slug
                        })
                    }
                } else {
                    const has_require_role =
                        child.require_auth == null ||
                        (child.require_auth === rootGetters['auth/is_authenticated'] &&
                            rootGetters['auth/has_role'](child.require_role))

                    // dont allow if auth is required with a specific role
                    if (!has_require_role) {
                        return
                    }

                    // dont allow blocked roles
                    if (child.blocked_roles && rootGetters['auth/has_role'](child.blocked_roles)) {
                        return
                    }

                    if (child.path) {
                        // if path is provided it is considered an external link
                        result.push({
                            url: child.path,
                            name: child.title,
                            icon: child.icon,
                            slug: child.slug
                        })
                    } else if (child.items) {
                        // Child is a heading
                        var items = findItems(child.items)
                        if (items.any()) {
                            result.push({
                                ...child,
                                items
                            })
                        }
                    } else if (child.submenu) {
                        // Child is a submenu
                        var submenu = findItems(child.submenu)
                        if (submenu.any()) {
                            result.push({
                                ...child,
                                submenu
                            })
                        }
                    }
                }
            })

            return result
        }
        return findItems(state.menuItems)
    },

    starredPages(state, getters) {
        return getters.searchables['pages'].data.filter((page) => page.is_bookmarked)
    },

    searchables(state, getters) {
        var searchables = getters.available_routes
            .filter((route) => {
                return route.meta && route.meta.searchable
            })
            .map((route) => {
                var search = `${route.meta.title}`
                if (route.meta && route.meta.param_restrictions) {
                    var params = Object.keys(route.meta.param_restrictions)

                    if (params.any()) {
                        params.forEach((param_name) => {
                            search += route.meta.param_restrictions[param_name].join('||')
                        })
                    }
                }

                return {
                    name: route.name,
                    url: route.path,
                    title: route.meta.title,
                    icon: route.meta.icon,
                    is_bookmarked: false,
                    search_string: search
                }
            })

        return {
            pages: {
                key: 'search_string',
                data: searchables
            }
        }
    }
}
